import { inject } from '@angular/core';
import { ActivatedRoute, CanActivateFn, Router } from '@angular/router';

import { PaymentStatus } from '@lyra/app/core/enums/payment-status';
import { RouteString } from '@lyra/app/core/enums/route-string';
import { PlanActionsService } from '@lyra/app/core/store/actions';

import { PaymentStatusCookieService } from '../services/payment-status-cookie.service';

/**
 * Checkout status guard — mirrors the core orderStatusGuard, but a successful payment lands on a
 * flow-specific login page (kept reachable for 24h via the success cookie) instead of the global
 * payment-successful page. Parameterized by the redirect: pass `[VMAIN, LOGIN]` for vmain,
 * `[ALI_PAGE_VARIANT_A, LOGIN]` for the ali flow, etc. The lang segment is prepended automatically.
 */
export const orderStatusGuard =
  (successPath: Array<RouteString>): CanActivateFn =>
  (route) => {
    const _router = inject(Router);
    const _activatedRoute = inject(ActivatedRoute);
    const _actions = inject(PlanActionsService);
    const _paymentStatusCookie = inject(PaymentStatusCookieService);
    if (route.queryParams && route.queryParams['status'] !== undefined) {
      if (route.queryParams['status'] === PaymentStatus.Success) {
        // Keep the successful-checkout marker for 24h so the login page (guarded by loginGuard) stays reachable.
        _paymentStatusCookie.setSuccess();
        _router.navigate(['/', route.params['lang'], ...successPath], {
          relativeTo: _activatedRoute,
          queryParamsHandling: 'merge',
          // change route without adding an empty route to the history (like redirectTo)
          replaceUrl: true,
        });
        return false;
      }
      _actions.paymentStatus(route.queryParams['status']);
    }

    return true;
  };
